module.exports = __webpack_public_path__ + "assets/img/3.f3184238.png";